import { FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import messages from './messages';

export const useHeaders = () => {
  const { housingVoucherCoverRentSwitch } = useFlags();

  return [
    {
      id: 'voucherSource',
      label: <FormattedMessage {...messages.voucherSource} />,
      dataType: 'string',
      sortable: true,
    },
    {
      id: 'voucherAmount',
      label: <FormattedMessage {...messages.voucherAmount} />,
      dataType: 'number',
      sortable: true,
    },
    {
      id: 'residentRent',
      label: <FormattedMessage {...messages.residentRent} />,
      dataType: 'number',
      sortable: true,
    },
    ...(housingVoucherCoverRentSwitch
      ? [
          {
            id: 'coversRentChanges',
            label: <FormattedMessage {...messages.coversRentIncreases} />,
            dataType: 'boolean',
            sortable: true,
          },
        ]
      : []),
    {
      id: 'voucherStartDate',
      label: <FormattedMessage {...messages.voucherStartDate} />,
      dataType: 'date',
      sortable: true,
    },
    {
      id: 'voucherEndDate',
      label: <FormattedMessage {...messages.voucherEndDate} />,
      dataType: 'date',
      sortable: true,
    },
    {
      id: 'actions',
      label: <FormattedMessage {...messages.actions} />,
    },
  ];
};

export const usePropertyPathMap = () => {
  const { housingVoucherCoverRentSwitch } = useFlags();

  const baseMap = {
    voucherSource: {
      path: 'voucherSource',
      dataType: 'string',
    },
    voucherAmount: {
      path: 'voucherAmount',
      dataType: 'number',
    },
    residentRent: {
      path: 'residentRent',
      dataType: 'number',
    },
    voucherStartDate: {
      path: 'voucherStartDate',
      dataType: 'date',
    },
    voucherEndDate: {
      path: 'voucherEndDate',
      dataType: 'date',
    },
  };

  if (housingVoucherCoverRentSwitch) {
    baseMap.coversRentChanges = {
      path: 'coversRentChanges',
      dataType: 'boolean',
    };
  }

  return baseMap;
};

export const DISABLE_REASON_MAP = {
  futureVoucher: 'addNewVoucherDisabledFutureTooltip',
  noMoveInDate: 'addNewVoucherDisabledNoMoveInTooltip',
};
